/**
 * Generate a basic quasi-unique ID.
 * For components, use `useId()` react hook instead
 */
export const generateBasicId = (prefix = 'id') =>
  `${prefix}-${Math.random().toString(36).substring(2, 15)}`;
